import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {finalize} from 'rxjs/operators';
import {HttpRequestService} from "./http-request.service";

/**
 * Marca las peticiones de fondo (el contador de mensajes, sus indicadores) para que no saquen el
 * «CARGANDO». Es un HttpContext y no una cabecera: una cabecera nueva viajaría a la API y el CORS
 * de producción, que fija Apache, no la admite.
 */
export const SIN_INDICADOR_CARGA = new HttpContextToken<boolean>(() => false);

/**
 * Ficheros estáticos del propio front (`assets/`), que no son datos: los SVG de los iconos los pide
 * `MatIconRegistry` la primera vez que se pintan, y la cápsula de acciones de las tablas sacaba el
 * «CARGANDO» al pasar el ratón por una fila con un icono aún sin descargar.
 */
const ESTATICO_DEL_FRONT = /^\/?assets\//;

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    constructor(private requestService: HttpRequestService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.context.get(SIN_INDICADOR_CARGA) || ESTATICO_DEL_FRONT.test(req.url)) {
            return next.handle(req);
        }

        // Aumenta el contador cuando se inicia una solicitud
        this.requestService.incrementRequests();

        return next.handle(req).pipe(
            finalize(() => {
                // Disminuye el contador cuando la solicitud se ha completado
                this.requestService.decrementRequests();
            })
        );
    }
}
